<template>
  <v-dialog v-model="dialog" :color="color" max-width="400" persistent>
    <v-card>
      <v-card-title>ยืนยัน</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="$emit('confirm', true)">ยืนยัน</v-btn>
        <v-btn @click="$emit('confirm', false)">ยกเลิก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    color: String,
    message: String  
  }
}
</script>